import PlacementApiUtils from '../utils/api/placement';
import { addMessage as addFlashMessage } from './flash';
import { addMessage as addModalMessage, hide as hideModal } from './modal';

export const FETCH_PLACEMENT_SENT = 'FETCH_PLACEMENT_SENT';
export const FETCH_PLACEMENT_SUCCEEDED = 'FETCH_PLACEMENT_SUCCEEDED';
export const FETCH_PLACEMENT_FAILED = 'FETCH_PLACEMENT_FAILED';
export const FETCH_MY_PLACEMENT_SENT = 'FETCH_MY_PLACEMENT_SENT';
export const FETCH_MY_PLACEMENT_SUCCEEDED = 'FETCH_MY_PLACEMENT_SUCCEEDED';
export const FETCH_MY_PLACEMENT_FAILED = 'FETCH_MY_PLACEMENT_FAILED';
export const CREATE_PLACEMENT_SENT = 'CREATE_PLACEMENT_SENT';
export const CREATE_PLACEMENT_SUCCEEDED = 'CREATE_PLACEMENT_SUCCEEDED';
export const CREATE_PLACEMENT_FAILED = 'CREATE_PLACEMENT_FAILED';
export const UPDATE_PLACEMENT_SENT = 'UPDATE_PLACEMENT_SENT';
export const UPDATE_PLACEMENT_SUCCEEDED = 'UPDATE_PLACEMENT_SUCCEEDED';
export const UPDATE_PLACEMENT_FAILED = 'UPDATE_PLACEMENT_FAILED';

export function fetchOneSent() {
  return { type: FETCH_PLACEMENT_SENT };
}

export function fetchOneSucceeded(data) {
  return {
    type: FETCH_PLACEMENT_SUCCEEDED,
    payload: data,
  };
}

export function fetchOneFailed(error) {
  return {
    type: FETCH_PLACEMENT_FAILED,
  };
}

export function fetchOneByStudentId(id, locale = 'en') {
  return (dispatch) => {
    return PlacementApiUtils.fetchOneByStudentId(id, locale).then(
      (data) => dispatch(fetchOneSucceeded(data)),
      (error) => dispatch(fetchOneFailed(error)),
    );
  };
}

export function fetchMineSent() {
  return { type: FETCH_MY_PLACEMENT_SENT };
}

export function fetchMineSucceeded(data) {
  return {
    type: FETCH_MY_PLACEMENT_SUCCEEDED,
    payload: data,
  };
}

export function fetchMineFailed(error) {
  return {
    type: FETCH_MY_PLACEMENT_FAILED,
  };
}

export function fetchMine(userId) {
  return (dispatch) => {
    dispatch(fetchMineSent());
    return PlacementApiUtils.fetchOneByStudentId(userId).then(
      (data) => dispatch(fetchMineSucceeded(data)),
      (error) => dispatch(fetchMineFailed(error)),
    );
  };
}

export function createSent() {
  return { type: CREATE_PLACEMENT_SENT };
}

export function createSucceeded(data) {
  return {
    type: CREATE_PLACEMENT_SUCCEEDED,
    payload: data,
  };
}

export function createFailed(error) {
  return { type: CREATE_PLACEMENT_FAILED };
}

export function create(studentId, levelId) {
  return (dispatch) => {
    dispatch(createSent());
    return PlacementApiUtils.create(studentId, levelId).then(
      (data) => {
        dispatch(hideModal());
        dispatch(
          addFlashMessage('Successfully created the summary.', {
            type: 'success',
            autoDisappear: true,
            sticky: true,
          }),
        );
        dispatch(createSucceeded(data));
      },
      (error) => {
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: true,
            type: 'error',
          }),
        );
        dispatch(createFailed(error));
      },
    );
  };
}

export function updateSent() {
  return { type: UPDATE_PLACEMENT_SENT };
}

export function updateSucceeded(data) {
  return {
    type: UPDATE_PLACEMENT_SUCCEEDED,
    payload: data,
  };
}

export function updateFailed(error) {
  return { type: UPDATE_PLACEMENT_FAILED };
}

export function update(studentId, levelId) {
  return (dispatch) => {
    dispatch(updateSent());
    return PlacementApiUtils.update(studentId, levelId).then(
      (data) => {
        dispatch(hideModal());
        dispatch(
          addFlashMessage('Successfully updated the summary.', {
            type: 'success',
            autoDisappear: true,
            sticky: true,
          }),
        );
        dispatch(updateSucceeded(data));
      },
      (error) => {
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: true,
            type: 'error',
          }),
        );
        dispatch(updateFailed(error));
      },
    );
  };
}
